module.exports = __webpack_public_path__ + "img/client-umami.6e826d18.png";